export default __webpack_public_path__ + "static/media/SourceSerifPro-SemiBold.b27cb117.ttf";